import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { SelectItem } from 'primeng/api';
import { Frm } from '../../components/frm/frm.interface';
import { OrgaoJustica } from '../../orgao-justica/orgao-justica.model';
import { OrgaoJusticaService } from '../../orgao-justica/orgao-justica.service';
import { SelectItemService } from '../../services/select-item.service';
import { OrgaoJulgador } from '../orgao-julgador.model';
import { OrgaoJulgadorService } from '../orgao-julgador.service';
import { Jurisdicao } from './../../jurisdicao/jurisdicao.model';
import { JurisdicaoService } from './../../jurisdicao/jurisdicao.service';

@Component({
  selector: 'app-orgao-julgador-frm',
  templateUrl: './orgao-julgador-frm.component.html',
  styleUrls: ['./orgao-julgador-frm.component.css'],
})
export class OrgaoJulgadorFrmComponent implements OnInit, Frm<OrgaoJulgador, number> {
  entidade: OrgaoJulgador;
  tipoJusticaItens: SelectItem[];
  naturezaItens: SelectItem[];
  orgaoJusticaItens: OrgaoJustica[];
  jurisdicaoItens: Jurisdicao[];
  instanciaItens: SelectItem[];

  constructor(
    private service: OrgaoJulgadorService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private orgaoJusticaService: OrgaoJusticaService,
    private jurisdicaoService: JurisdicaoService,
    private selectItemService: SelectItemService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.orgaoJusticaService
      .recuperarItens()
      .then((orgaoJustica) => {
        this.orgaoJusticaItens = orgaoJustica;
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro ao encontrar orgãos justiça: ', resposta.error);
      });
    this.jurisdicaoService
      .recuperarItens()
      .then((jurisdicoes) => {
        this.jurisdicaoItens = jurisdicoes;
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro ao encontrar as jurisdições: ', resposta.error);
      });
    this.instanciaItens = this.selectItemService.getInstanciaItens();
  }

  salvar(): void {
    const isInsercao = this.entidade.id === undefined;

    this.progressoService.modal();
    this.service
      .salvar(this.entidade)
      .then((orgaoJulgador) => {
        this.entidade = orgaoJulgador;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'O órgão julgador foi salvo com sucesso');

        if (isInsercao) {
          this.location.go(`/fonteDados/edicao/${this.entidade.id}`);
        }
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar a fonte de dados', resposta.error);
        this.progressoService.fechar();
      });
  }

  iniciarInsercao(): void {
    this.mensagemService.addErro(
      'Erro não implementado',
      'O cadastro de órgão julgadores devem ser realizado no sistema Corporativo!'
    );
  }

  iniciarAlteracao(entidade: OrgaoJulgador): void {
    this.entidade = entidade;
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service
      .recuperarPorId(id)
      .then((orgaoJulgador) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(orgaoJulgador);
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar o órgão julgador para edição', resposta.error);
      });
  }
}
